import React, { useEffect, useState } from "react";
// import Aos from "aos";
// import Breadcrumbs from "../common/breadcrumbs";
import DashboardMenu from "./common/dashboard-menu";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getProfile, getRecommendedVehicle } from "../../core/data/redux/action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../core/data/redux/store";
import { Calendar } from "primereact/calendar";
// import { format } from 'date-fns';
// import Pagination from "../common/pagination";
import Lottie from "lottie-react";
import Loader from "../../core/data/img/car_loading.json";

// import {  userBookingsData } from "../../core/data/json/user_bookings";
import { all_routes } from "../router/all_routes";

// import ViewBooking from "../../core/data/modals/viewBooking";
import CancelBooking from "../../core/data/modals/cancelBooking";
// import BookingPayment from "../booking/booking-payment";
// import { useNavigate } from "react-router-dom";

const UserPendingBookings = () => {
    const routes = all_routes;
    const [userBookings, setUserBookings] = useState<any[]>([]);

    // const [filteredData, setFilteredData] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [activeStatus, setActiveStatus] = useState<number | null>(null);
    const [dates, setDates] = useState<Date[]>([]);
    const [booking] = useState("");
    // useEffect(() => {
    //   Aos.init({ duration: 1200, once: true });
    //   userBookingsData
    //     .getUserBookingsMedium()
    //     .then((data) => setUserBookings(data));
    // }, []);

    // const navigate = useNavigate();

    const { vehicleRecommendationList, user, bookingStatusList, vehicleRecommendationLoading } = useSelector(
        (state: RootState) => ({
            // bookings: state.booking.bookings,
            bookingStatusList: state.booking.bookingStatusList,
            //  bookingsLoading: state.booking.bookingsLoading,
            user: state.auth.user,
            vehicleRecommendationLoading: state.vehicleRecommendation.vehicleRecommendationLoading,
            vehicleRecommendationList: state.vehicleRecommendation.vehicleRecommendationList,

        })
    );

    const dispatch = useDispatch<AppDispatch>();


 
    useEffect(() => {
        setUserBookings(
            vehicleRecommendationList?.recommendation
                ? [vehicleRecommendationList.recommendation]
                : []
        );
        // setFilteredData(bookings?.data?.data);
    }, [vehicleRecommendationList]);



    // const viewBooking = (url: string) => {
    //  dispatch(getBooking(id));
    // }

    // useEffect(() => {
    //   const today = new Date();
    //   const sevenDaysAgo = new Date();
    //   sevenDaysAgo.setDate(today.getDate() - 7);

    //   setDates([sevenDaysAgo, today]);

    // }, []);


    // const [first, setFirst] = useState(0);
    // const [loading, setLoading] = useState(false);


    // const filteredData = Array.isArray(userBookings)
    //   ? userBookings.filter((booking) => {
    //     const values = Object.values(booking).map((value: any) => {

    //       return value != null ? value.toString().toLowerCase() : "";
    //     });
    //     return values.some((value) =>
    //       value.includes(searchInput?.toLowerCase() || "")
    //     );
    //   })
    //   : [];



    const [debouncedSearch, setDebouncedSearch] = useState(searchInput);



    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchInput);
        }, 500); // 500ms delay

        return () => clearTimeout(handler);
    }, [searchInput]);

    useEffect(() => {
        if (localStorage.getItem("token")) {

            dispatch(getProfile());
        }

        // dispatch(getBookingStatus());
    }, [dispatch]);

    // const [selectedBookingId, setSelectedBookingId] = useState<string | null>(
    //     null
    // );
    // const [initialPayment, setInitialPayment] = useState<number | null>(null);


    // const handlePaymentClick = (event: React.MouseEvent, bookingId: string, initialPayment: number) => {
    //     event.preventDefault();
    //     setSelectedBookingId(bookingId);
    //     setInitialPayment(initialPayment);
    // };


    useEffect(() => {
        // setFirst(1);


        dispatch(
            getRecommendedVehicle()
        );
    }, [dates, activeStatus, debouncedSearch]);



    // const carName = (res: any) => {
    //     return (
    //         <div className="table-avatar">
    //             <div className="table-head-name flex-grow-1">
    //                 <p>{res?.vehicle_name}</p>
    //             </div>
    //         </div>
    //     );
    // };

    // const pickupLocation = (res: any) => {
    //     return (
    //         <p className="text-wrap">
    //             {res?.pickup_location}
    //         </p>
    //     );
    // };


    const vehicleDetails = (res: any) => {
        return (
            <>
                <p className="text-wrap">   {res?.vehicle?.year_make_model} </p>

                {/* <p > <span className="fw-bold">  VIN:  </span>  {res?.vehicle?.vin} </p>

                <p > <span className="fw-bold">  Plate Number:  </span>  {res?.vehicle?.plate_number} </p> */}

            </>

        );
    };

    const UserDetails = (res: any) => {
        return (
            <p>{res?.user?.name}</p>
        );
    };

    // const BookingType = (res: any) => {
    //   const rentalType = res?.rental_type
    //     ? res.rental_type.charAt(0).toUpperCase() + res.rental_type.slice(1).toLowerCase()
    //     : "";

    //   return <p>{rentalType}</p>;
    // };


    const PaymentMethod = (res: any) => {
        return (

            <p>  {res?.payment_method?.name} </p>


        );
    };

    const Expires = (res: any) => {
        const date = new Date(res?.token_expires_at);
        const formattedDate = date.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true, // Use false for 24-hour format

        });


        return (
            <p>
                {formattedDate}
            </p>
        );
    };


    const SetDate = (date: string, time: string) => {
        if (!date && !time) return <p>--</p>;

        const set_date = new Date(date);
        const formattedDate = set_date?.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });

        // Format time to 12-hour format with AM/PM
        const set_time = new Date(`1970-01-01T${time}`);
        const formattedTime = set_time?.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });

        return (
            <p>
                {formattedDate}, {formattedTime}
            </p>
        );
    };


    const TripDate = (res: any) => {

        return (
            <p>
                {SetDate(res?.start_date, res?.start_time)} - {SetDate(res?.return_date, res?.return_time)}
            </p>
        );
    };


 

    const status = (res: any) => {
        return (
            <span

                className={` ${res?.status == "open"
                    ? "badge badge-light-success"
                    : res?.status == "booked"
                        ? "badge badge-light-info"
                        : res?.status == "expired"
                            ? "badge badge-light-danger"
                            : res?.status == "closed_by_admin"
                                ? "badge badge-light-warning"
                                : "badge badge-light-secondary"
                    }`}
            >

                {res?.status
                    ?.toLowerCase()
                    .replace(/_/g, " ") // Replace underscores with spaces
                    .replace(/^\w/, (c: string) => c.toUpperCase())}

            </span>
        );
    };

    const action = () => {
        return (

            <a
                className="dropdown-item px-0"
                href={vehicleRecommendationList?.bookingUrl}


            >
                <i className="feather icon-eye pe-1" /> View
            </a>

            // <div className="dropdown dropdown-action ">
            //     <a
            //         href="#"
            //         className="dropdown-toggle"
            //         data-bs-toggle="dropdown"
            //         aria-expanded="false"
            //     >
            //         <i className="fas fa-ellipsis-vertical" />
            //     </a>
            //     <div className="dropdown-menu dropdown-menu-end">
            //         <a
            //             className="dropdown-item"
            //             href={vehicleRecommendationList?.bookingUrl}


            //         >
            //             <i className="feather icon-eye" /> View
            //         </a>



            //         {/* <a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#cancel_booking"

            //             onClick={() => {
            //                 setBooking(res);
            //             }}
            //         >
            //             <i className="feather icon-eye" /> Cancel Booking
            //         </a> */}

            //     </div>
            // </div>
        );
    };




    // const [rows, setRows] = useState(10); // Number of rows per page

    // const onPageChange = (event) => {
    //  // dispatch(getAllBooking({ itemsPerPage: event.rows, page: event.page, status_id: activeStatus, from_date: dates[0]?.toISOString(), to_date: dates[1]?.toISOString(), search: searchInput }));
    //   setRows(event.rows);

    // };


    // const onPage = (event: any) => {
    //   // setLoading(true);

    //   // setRows(event.rows);
    //   //imitate delay of a backend call
    //   setTimeout(() => {
    //     const startIndex = event.first;
    //     const endIndex = event.first + event.rows;

    //      setFirst(startIndex);
    //     setUserBookings(bookings?.data?.data?.slice(startIndex, endIndex));
    //     //   setLoading(false);
    //   }, 250);
    // }

    // const onPage = (event: any) => {
    //     setFirst(event);
    //     window.scrollTo(0, 0);

    //     dispatch(getAllBooking({
    //         itemsPerPage: event.rows, page: event, status_id:
    //             activeStatus, from_date: dates[0]?.toISOString(), to_date: dates[1]?.toISOString(), search: searchInput
    //     }));

    // }


    return (
        <>
            {/* <Breadcrumbs title="User Bookings" subtitle="User Bookings" /> */}
            <DashboardMenu />

            <div className="content">
                <div className="container">
                    {/* Content Header */}
                    {/* <div className="content-header">
            <h4>My Bookings</h4>
          </div> */}
                    {/* /Content Header */}
                    {/* Sort By */}
                    <div className="row d-none d-md-block">
                        <div className="col-lg-12">
                            <div className="sorting-info">
                                <div className="row d-flex align-items-center">
                                    <div className="col-xl-12 col-lg-8 col-sm-12 col-12 ">
                                        <div className="booking-lists">



                                            <ul className="nav">
                                                <li onClick={() => {
                                                    setActiveStatus(null);
                                                }} >
                                                    <Link className={activeStatus === null ? "active" : ""} to={routes.userBookings}>Pending Bookings</Link>
                                                </li>


                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Sort By */}
                    <div className="row">
                        {/* All Bookings */}
                        {vehicleRecommendationLoading ?
                            <div className="d-flex justify-content-center align-items-center">
                                <Lottie animationData={Loader} loop={true} style={{ width: 300, height: 300 }} />
                            </div>
                            :
                            <div className="col-lg-12 d-flex">
                                <div className="card book-card flex-fill mb-0">
                                    <div className="card-header mt-0 pt-0 px-0">
                                        <div className="row align-items-center">
                                            <div className="col-8  col-md-5">



                                                <h4 className="align-items-center mb-0">
                                                    {bookingStatusList && activeStatus && bookingStatusList.length > 0
                                                        ? bookingStatusList
                                                            .filter((item: any) => item.id === activeStatus)
                                                            .map(({ name }: any) =>
                                                                name
                                                                    ?.toLowerCase()
                                                                    .replace(/_/g, " ") // Replace underscores with spaces
                                                                    .replace(/^\w/, (c: string) => c.toUpperCase())
                                                            )
                                                        : "Pending Bookings "}

                                                    <span>{userBookings?.length}</span>
                                                </h4>




                                            </div>

                                            <div className="col-4 d-block d-md-none">

                                                <div className="d-md-none d-flex align-items-center justify-content-end gap-2">


                                                </div>

                                            </div>

                                            <div className="col-12 col-md-7 text-md-end d-none d-md-block">
                                                <div className="row table-search">
                                                    <div id="tablefilter" className="col-12 col-md-4 me-md-0 pe-md-0">
                                                        <label className="d-flex">
                                                            <input
                                                                type="text"
                                                                value={searchInput}
                                                                onChange={(e) => setSearchInput(e.target.value)}

                                                                placeholder="Search"
                                                                className="form-control inputsearch"
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className="col-12 col-md-4 " >

                                                        <label className="me-1 mt-1 ">
                                                            <Calendar
                                                                className="  bg-custom py-2"
                                                                value={dates.length ? dates : []} // Ensure it's always an array
                                                                onChange={(e: any) => setDates(e.value || [])} // Fallback to empty array
                                                                placeholder="Choose Date Range"
                                                                selectionMode="range"
                                                                style={{
                                                                    padding: "0px"
                                                                }}
                                                            />

                                                        </label>

                                                        {/* <Link to={routes.listingGrid} className="btn btn-add py-1 my-1">
                              <i className="feather icon-plus-circle" />
                              <span className="d-none d-md-block">  Add Booking</span>
                            </Link> */}


                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className="table-responsive dashboard-table">
                                            <DataTable
                                                className="table datatable"
                                                value={userBookings || []}
                                                // paginator
                                                // rowsPerPageOptions={[10, 25, 50]}
                                                // rows={rows}
                                                // totalRecords={bookings?.data?.total ?? 0}
                                                // first={first}
                                                // lazy
                                                // onPage={onPage}
                                                selectionMode="single"
                                            >
                                                {/* <Column body={checkbox} header={checkbox}></Column> */}
                                                <Column field="vehicle" header="Vehicle" body={vehicleDetails} className="w-50 "></Column>
                                                {user?.isAdmin && <Column field="user" header="User" body={UserDetails}></Column>}
                                                {/* <Column field="carName" header="Car Name" body={carName}   ></Column> */}
                                                {/* <Column field="BookingType " header="Booking Type " body={BookingType}></Column>   */}
                                                {/* <Column field="location" header={<>Pickup/Dropoff Location</>} body={pickupLocation} /> */}
                                                <Column field="Expires" header="Expires" body={Expires}> </Column>
                                                <Column field="tripDate" header="Trip Date" body={TripDate}> </Column>

                                                <Column field="paymentMethod" header="Payment Method" body={PaymentMethod}>     </Column>
                                                <Column
                                                    field="status"
                                                    header="Status"
                                                    body={status}
                                                ></Column>
                                                <Column
                                                    field="action"
                                                    header="Action"
                                                    body={action}

                                                ></Column>
                                            </DataTable>

                                            <div className="d-flex justify-content-center justify-content-md-end p-2 my-2">

                                                {/*Pagination*/}
                                                {/* <Pagination
                                                    currentPage={first || 1}
                                                    totalPages={bookings?.data?.last_page || 1}
                                                    onPageChange={onPage}
                                                /> */}
                                                {/*/Pagination*/}
                                            </div>

                                        </div>
                                        <div className="table-footer">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div id="tablelength" />
                                                </div>
                                                <div className="col-md-6 text-md-end">
                                                    <div id="tablepage" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        {/* /All Bookings */}
                    </div>
                    {/* /Dashboard */}
                </div>
            </div>


            {/* /Upcoming Booking */}

            {/* <ViewBooking  SetDate={SetDate} /> */}

            <CancelBooking booking={booking} />

            {/* {
                <div
                    className="modal new-modal multi-step fade"
                    id="make_payment"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close-btn"
                                    data-bs-dismiss="modal"
                                >
                                    <span>×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                               
                            </div>
                        </div>
                    </div>
                </div>
            } */}


            <div className="offcanvas offcanvas-end" tabIndex={33} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div className="offcanvas-header">

                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => {
                        document.body.style.overflow = "";
                        document.body.style.paddingRight = "";
                    }}></button>
                </div>
                <div className="offcanvas-body">
                    <form
                        // onSubmit={handleSubmit}
                        action="#"
                        autoComplete="off"
                        className=""
                    >


                        <div className="row table-search">
                            <div id="tablefilter" className="col-12 col-md-5 me-md-0 pe-md-0">
                                <label className="d-flex">
                                    <input
                                        type="text"
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}

                                        placeholder="Search"
                                        className="form-control inputsearch"
                                    />
                                </label>
                            </div>
                            <div className="col-12 col-md-6 " >

                                <label className="me-2 mt-1 d-flex">
                                    <Calendar
                                        className="  bg-custom py-2"
                                        value={dates.length ? dates : []} // Ensure it's always an array
                                        onChange={(e: any) => setDates(e.value || [])} // Fallback to empty array
                                        placeholder="Choose Date Range"
                                        selectionMode="range"
                                        style={{
                                            padding: "0px"
                                        }}
                                    />

                                </label>


                            </div>


                            <div className="col-12 col-md-6 " >

                                <label className="me-2 my-1 d-flex">
                                    <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        onChange={(e) => setActiveStatus(parseInt(e.target.value))}
                                    >
                                        <option value="" className="fs-12">Select Status</option>
                                        {bookingStatusList?.map(({ id, name }: any) => (
                                            <option key={id} value={id} className="fs-12">
                                                {name
                                                    ?.toLowerCase()
                                                    .replace(/_/g, " ") // Replace underscores with spaces
                                                    .replace(/^\w/, (c: string) => c.toUpperCase())} {/* Capitalize first letter */}
                                            </option>
                                        ))}
                                    </select>

                                </label>


                            </div>

                            <div className="col-12 mt-1 " >
                                <button
                                    type="button"
                                    className="d-inline-flex align-items-center justify-content-center btn btn-primary filter-btn"
                                    data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => {
                                        document.body.style.overflow = "";
                                        document.body.style.paddingRight = "";
                                    }}
                                >
                                    <span>
                                        <i className="feather icon-filter fs-12 me-2" />
                                    </span>
                                    Apply Filter
                                </button>
                            </div>

                        </div>




                    </form>

                </div>
            </div>



        </>
    );
};

export default UserPendingBookings;
